import { Checkbox, Text, CheckboxProps } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface Props extends CheckboxProps {
	bold?: boolean;
	textColor?: string;
}

export const TSCheckbox = ({ children, bold, textColor, ...props }: PropsWithChildren<Props>) => {
	return (
		<Checkbox
			{...props}
			label={
				<Text c={textColor} fz={14} fw={bold ? 600 : 400} ta="center">
					{children}
				</Text>
			}
			styles={{
				body: {
					alignItems: 'center',
				},
			}}
		/>
	);
};
